import { FileNameAnalysisResult } from './FileNameAnalysisResult ';

export class AloGliderFileListReport {
  //FileNameAnalysisResult  {
  public fileResults:Array<FileNameAnalysisResult>

  constructor({ fileResults}: {fileResults: Array<any>}) {
    this.fileResults = fileResults.map(f => new FileNameAnalysisResult(f))   
  }  

  static createAloGliderFileListReport(data:any) {
    return new AloGliderFileListReport(data)
  }
}
